import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { getDeck } from '../../utils/cardDecks';

const CompactCardDeck = ({
  deckType = 'fibonacci',
  selectedValue,
  onSelect,
  disabled = false,
  size = 'small'
}) => {
  const deck = getDeck(deckType);

  const getButtonSize = () => {
    switch (size) {
      case 'small':
        return { minWidth: 32, height: 40, fontSize: '0.75rem', px: 0.5 };
      case 'medium':
        return { minWidth: 40, height: 48, fontSize: '0.875rem', px: 1 };
      default:
        return { minWidth: 32, height: 40, fontSize: '0.75rem', px: 0.5 };
    }
  };

  const buttonStyles = getButtonSize();

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        justifyContent: 'flex-start'
      }}
    >
      {deck.map((value) => {
        const isSelected = selectedValue === value;
        const isSpecial = value === '?' || value === '☕';

        return (
          <Tooltip key={value} title={value === '?' ? 'Not sure' : value === '☕' ? 'Need break' : value}>
            <Button
              variant={isSelected ? 'contained' : 'outlined'}
              color={isSpecial ? 'secondary' : 'primary'}
              onClick={() => onSelect(value)}
              disabled={disabled}
              sx={{
                ...buttonStyles,
                fontWeight: isSelected ? 'bold' : 'normal',
                ...(isSelected && {
                  boxShadow: 3,
                  transform: 'scale(1.1)'
                }),
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: disabled ? 'none' : 'scale(1.05)'
                }
              }}
            >
              {value}
            </Button>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default CompactCardDeck;
